import { ensureAsync } from 'async';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
export const colors = [
	'rgba(96, 209, 126)',
	'rgba(250, 140, 92)',
	'rgba(69, 175, 237)',
	'rgba(124, 92, 219, 0.8)',
	'rgba(206, 92, 219, 0.8)',
	'rgba(219, 92, 151, 0.8)',
	'rgba(159, 201, 52, 0.8)',
	'rgba(252, 186, 3, 0.8)',
	'rgba(96, 209, 126)',
	'rgba(250, 140, 92)',
	'rgba(69, 175, 237)',
	'rgba(124, 92, 219, 0.8)',
	'rgba(206, 92, 219, 0.8)',
	'rgba(219, 92, 151, 0.8)',
	'rgba(159, 201, 52, 0.8)',
	'rgba(252, 186, 3, 0.8)',
];
const SalesLeftBar = ({ salesSku, salesQuery, salesData }) => {
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [salesName, setSalesName] = useState('Brand');
	const [channelNames, setChannelNames] = useState([]);
	const [channelName, setChannelName] = useState('Brand');
	useEffect(() => {
		if (salesData && salesData.lineData) {
			setRowsData(salesData.lineData);
		}
	}, [salesData]);

	function capitalize(str) {
		const lower = str.toLowerCase();
		return str.charAt(0).toUpperCase() + lower.slice(1);
	}
	// console.log('rowsData', rowsData);
	// console.log('salesData', salesData);
	// console.log('currentData', currentData);
	// console.log('salesSku', salesSku);

	useEffect(() => {
		if (salesSku && salesSku[0] && rowsData) {
			const filterSales = salesSku[0].value; // sales Quantity, Sales
			const filterCategory = salesSku[1] && salesSku[1].value; // brand , Chain
			let data;
			if (filterCategory) {
				setChannelName(filterCategory);
			}
			if (filterCategory && filterSales) {
				const chanNames = [];
				const allData = [];
				rowsData[filterCategory] &&
					rowsData[filterCategory][filterSales].forEach((e) => {
						if (e.label) {
							chanNames.push(e.label);
						}
						if (e.data) {
							const d = e.data.reduce((a, b) => a + b);
							allData.push(d);
						}
					});

				setChannelNames(chanNames);
				setCurrentData(allData);
			} else if (filterSales || !filterSales) {
				const chanNames = [];
				const allData = [];
				let filterD = 'Sales';
				if (filterSales) {
					filterD = filterSales;
				}
				rowsData['Brand'] &&
					rowsData['Brand'][filterD].forEach((e) => {
						if (e.label) {
							chanNames.push(e.label);
						}
						if (e.data) {
							const d = e.data.reduce((a, b) => a + b);
							allData.push(d);
						}
					});

				setChannelNames(chanNames);
				setCurrentData(allData);
			}
		}
	}, [rowsData, salesSku]);

	const data = {
		labels: channelNames,
		datasets: [
			{
				axis: 'y',
				label: ``,
				fill: false,
				data: currentData,
				backgroundColor: colors,
			},
		],
	};

	const options = {
		indexAxis: 'y',
		maintainAspectRatio: false,
		scaleShowValues: true,
		// scales: {
		// 	yAxes: [
		// 		{
		// 			ticks: {
		// 				stacked: true,
		// 			},
		// 		},
		// 	],
		// },
		elements: {
			bar: {
				borderWidth: 2,
			},
		},
		plugins: {
			title: {
				display: true,
				text: channelName,
				font: {
					size: '20px',
				},
			},
			legend: {
				display: false,
			},
		},
	};

	return (
		<div>
			<Bar data={data} options={options} width={300} height={400} />
		</div>
	);
};

export default SalesLeftBar;
